export function normalizeProfileTags(tags) {
  const normalized = [...new Set((tags || [])
    .map((tag) => String(tag).trim().replace(/^#+/, '').toLowerCase())
    .filter(Boolean))];

  if (normalized.length > 8) throw new Error('Add up to 8 tags');
  if (normalized.some((tag) => tag.length > 20)) throw new Error('Tags must be 20 characters or fewer');
  return normalized;
}

export function validateProfileDraft({ username, displayName, bio, tags }) {
  const cleanUsername = String(username || '').trim().toLowerCase();
  const cleanDisplayName = String(displayName || '').trim();
  const cleanBio = String(bio || '').trim();

  if (cleanUsername.length < 3) throw new Error('Username must be at least 3 characters');
  if (!/^[a-z0-9_]+$/.test(cleanUsername)) {
    throw new Error('Username can only use lowercase letters, numbers, and underscores');
  }
  if (cleanUsername.length > 30) throw new Error('Username can be up to 30 characters');
  if (!cleanDisplayName) throw new Error('Display name is required');
  if (cleanDisplayName.length > 50) throw new Error('Display name can be up to 50 characters');
  if (cleanBio.length > 160) throw new Error('Bio can be up to 160 characters');

  return {
    username: cleanUsername,
    display_name: cleanDisplayName,
    bio: cleanBio,
    tags: normalizeProfileTags(tags),
  };
}

export function resolveReactionState(cachedState, fetchedState) {
  return cachedState === undefined ? !!fetchedState : !!cachedState;
}

export function normalizeCommentBody(body) {
  const clean = String(body || '').trim();
  if (!clean) throw new Error('Write a comment first');
  if (clean.length > 500) throw new Error('Comments can be up to 500 characters');
  return clean;
}

export function validateFeedbackDraft({ message, contactEmail }) {
  const cleanMessage = String(message || '').trim();
  if (!cleanMessage) throw new Error('Describe the bug or feedback first');
  if (cleanMessage.length > 5000) throw new Error('Feedback can be up to 5000 characters');

  const cleanEmail = String(contactEmail || '').trim();
  if (cleanEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cleanEmail)) {
    throw new Error('Contact email looks invalid');
  }

  return { message: cleanMessage, contactEmail: cleanEmail || null };
}

export function shapeComment(row) {
  return {
    id: row.id,
    postId: row.post_id,
    body: row.body,
    createdAt: row.created_at,
    author: {
      id: row.author?.id,
      handle: row.author?.username || 'unknown',
      name: row.author?.display_name || row.author?.username || 'Unknown',
      avatar: row.author?.avatar_url || null,
    },
  };
}
